import * as moment from 'moment';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ToastService } from 'ng-uikit-pro-standard';
import CustomStore from 'devextreme/data/custom_store';
import { DxSelectBoxComponent } from 'devextreme-angular';
import { ContactService } from 'src/app/services/contact.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { MapInformationService } from 'src/app/services/map-information.service';
import { MarketPoiInterface, MarketServiceInterface } from 'src/app/models/models.interface';
import { TranslateService } from '@ngx-translate/core';
import { SwoService } from 'src/app/services/swo.service';
@Component({
  selector: 'app-edit-service-work-order',
  templateUrl: './edit-service-work-order.component.html',
  styleUrls: ['./edit-service-work-order.component.scss']
})
export class EditServiceWorkOrderComponent implements OnInit {

  @Input() serviceID : any;

  newSWO = new FormGroup({
    serviceid: new FormControl({ value: '', disabled: true }, []),
    siteid: new FormControl({ value: '', disabled: false }, []),
    servicetype: new FormControl({ value: '', disabled: false }, []),
    servicecategoryid: new FormControl({ value: '', disabled: false }, []),
    requestedbyid: new FormControl({ value: '', disabled: false }, []),
    requestdate: new FormControl(""),
    customerpo: new FormControl({ value: '', disabled: false }, []),
    userid: new FormControl({ value: '', disabled: false }, []),
    resources: new FormControl({ value: '', disabled: false }, []),
    serviceestimatedhours: new FormControl(''),
    scheduledate: new FormControl({ value: "", disabled: false }, []),
    callahead: new FormControl(false),
    serviceconfirmed: new FormControl(false),
    projectid: new FormControl({ value: '', disabled: false }, []),
    priorityid: new FormControl({ value: '', disabled: false }, []),
    reasonforservice: new FormControl(''),
    Notify_Technician: new FormControl(false),
    status: new FormControl({ value: 0, disabled: false }, []),
    siteAddress: new FormControl({ value: "", disabled: true }, []),
    pmType: new FormControl({ value: "", disabled: false }, []),
    statusid: new FormControl({ value: 0, disabled: false }, []),
    pmtasks: new FormControl({ value: "", disabled: false }, []),
    servicedoneby: new FormControl({ value: "", disabled: false }, []),
  });

  siteID: any;
  // serviceID: any

  responsible: any;
  sitename: any;
  salesProject: any;
  siteDataSource: any
  plusSiteButton: any;
  popupServiceSite = false;

  dateFormat: any;

  lat:any
  lng:any

  request: any
  requestDataSource: any;
  reqDate = { todayButton: {}, prevDateButton: {}, nextDateButton: {}, showDate: new Date().getTime() };
  schedulatedDate = { todayButton: {}, prevDateButton: {}, nextDateButton: {}, showDate: new Date().getTime() };

  millisecondsInDay = 24 * 60 * 60 * 1000;

  status:any
  createdBy: any;

  loadInfo = {
    siteid: [],
    servicetype: [],
    servicecategoryid: [],
    requestedbyid: [],
    // requestdate: [],
    customerpo: "",
    userid: [],
    resources: [],
    // subcontractorid: [],
    // scheduledate: [],
    serviceconfirmed: [],
    projectid: [],
    priorityid: [],
    reasonforservice: "",
    pmType: [],
    status: []
  };

  siteAddress: any = "";
  createdDate: any;
  nombreNavigateTo : any;
  servicesid : any;
  pmtype: any[]=[];
  type = "";
  priority = "";
  category = "";
  recursos: any[]= [];
  callahead: any;

  serviceestimatedhours: any;
  serviceconfirmed: any;
  projectDataSource: any;
  ResponsibleDataSource: any;
  plusContactButton: any;
  popupNewContact: boolean = false;
  plusSalesProjectButton: any;
  popupCreateSalesProject: boolean = false;
  plusResponsibleButton: { icon: string; type: string; onClick: () => void; };
  popupResponsible: boolean = false;
  plusResourcesButton: { icon: string; type: string; onClick: () => void; };
  popupResources: boolean = false;

  @ViewChild("newSiteSelect", { static: false }) newSiteSelect: DxSelectBoxComponent;
  @ViewChild("newProjectSelect", { static: false }) newProjectSelect: DxSelectBoxComponent;
  @ViewChild("newRequestSelect", { static: false }) newRequestSelect: DxSelectBoxComponent;
  @ViewChild("newResponsibleSelect", { static: false }) newResponsibleSelect: DxSelectBoxComponent;

  @Output() onsubmit = new EventEmitter<any>();

  constructor(
    private router: Router,
    private pipeDate: DatePipe,
    private toast: ToastService,
    public swoService:SwoService,
    private translate:TranslateService,
    private contactService: ContactService,
    public MapInformationService: MapInformationService,
  ) { }

  ngOnInit() {
    this.inputsDate(this.reqDate);
    this.inputsDate(this.schedulatedDate);

    this.plusSiteButton = {
      icon:"plus",
      type: "button",
      hint:"New service site",
      onClick: () => {
          this.popupServiceSite = true;
      }
    };

    this.plusContactButton = {
      icon:"plus",
      type: "button",
      hint:"New Contact",
      onClick: () => {
        this.popupNewContact = true; // ---------------
      }
    };

    this.plusSalesProjectButton = {
      icon: "plus",
      type: "button",
      hint:"Create new Sales project",
      onClick: () => {
        this.popupCreateSalesProject = true // ---------------
      }
    };

    this.plusResponsibleButton = {
      icon:"plus",
      type: "button",
      onClick: () => {
          this.popupResponsible = true // ---------------
      }
    };

    this.plusResourcesButton = {
      icon:"plus",
      type: "button",
      onClick: () => {
          this.popupResources = true // ---------------
      }
    };

    this.initVarible();
    this.GetAllInfo(this.serviceID);
  }

  editSite(){
    localStorage.removeItem('newSite')
    localStorage.removeItem('VolverEditSWO')
    localStorage.setItem('newSite',this.siteID)
    localStorage.setItem('VolverEditSWO',this.serviceID)
    this.router.navigate(['/serviceSites/editServiceSite']);
  }

  updateForm(item,tipo_select) {

    switch(tipo_select){
      case 'Responsible':
        if (item.selectedItem && item.selectedItem.ID) {
          this.newSWO.get('servicedoneby').setValue(item.selectedItem.ID);
          this.responsible = item.selectedItem.EMPLOYEENAME
        }
      break
      case 'Site_Name':
        console.log(item)
        if (item.selectedItem && item.selectedItem.ID) {
          this.newSWO.get('siteid').setValue(item.selectedItem.ID);
          this.sitename = item.selectedItem.name
        }
      break
      case 'Sales_Project':
        if (item.selectedItem && item.selectedItem.ID) {
          this.newSWO.get('projectid').setValue(item.selectedItem.ID);
          this.salesProject = item.selectedItem.Description
        }
      break
    }
  }

  GoToMap(){
    let data = {
      Lat: this.lat,
      lng: this.lng
    }
    localStorage.removeItem('SiteData')
    localStorage.setItem('SiteData',JSON.stringify(data))
    this.router.navigateByUrl('/services-map');
  }

  updateOwener(item) {
    if (item.selectedItem && item.selectedItem.ID) {
      this.newSWO.get('requestedbyid').setValue(item.selectedItem.ID);
      this.request = item.selectedItem.First
    }
  }

  editContact(){
    localStorage.removeItem("VolvereditSWO")
    localStorage.setItem("VolvereditSWO",this.serviceID)
    this.router.navigateByUrl(`/contacts/editContact/${this.newSWO.value.requestedbyid}`);
  }

  inputsDate(date) {
    date.todayButton = {
      text: this.translate.instant('btnToday'),
      onClick: () => {
        date.showDate = new Date().getTime();
      }
    };

    date.prevDateButton = {
      icon: "spinprev",
      stylingMode: "text",
      onClick: () => {
        date.showDate -= this.millisecondsInDay;
      }
    };

    date.nextDateButton = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        date.showDate += this.millisecondsInDay;
      }
    };
  }

  serviceDoneBy: any
  serviceDoneDate: any

  GetAllInfo(param){
    this.loadInfo = {
      siteid: [],
      servicetype: [],
      servicecategoryid: [],
      requestedbyid: [],
      // requestdate: [],
      customerpo: "",
      userid: [],
      resources: [],
      // subcontractorid: [],
      // serviceestimatedhours: [],
      // scheduledate: [],
      serviceconfirmed: [],
      projectid: [],
      priorityid: [],
      reasonforservice: "",
      pmType:[],
      status:[]
    };

    const infoPrincipal = {
      method:'GetServiceInfoCE',
      serviceid:param
    }
    console.log(infoPrincipal);
    // this.MapInformationService.GetOrderByID('Get_ServiceByID',param)
    this.MapInformationService.SaveInfoSites(infoPrincipal)
    .subscribe(datos=>{
      console.log(datos);
      this.MapInformationService.GetSitesByID("Get_SiteInfo",datos[0].SITEID)
      .subscribe(sites=>{
        this.MapInformationService.GetAllInfo('GetServicePriorityCE')
        .subscribe(priority=>{
          this.MapInformationService.GetAllInfo('Get_EmployeeListAll')
          .subscribe(resources=>{
            this.MapInformationService.GetAllInfo('Get_ServiceTypes')
            .subscribe(allCategory=>{
              this.MapInformationService.GetAllInfo('Get_SerCategory')
              .subscribe(allTypes=>{
                this.MapInformationService.GetAllInfo('Get_Service_PMTask_Type')
                .subscribe(PMtype=>{
                  this.MapInformationService.GetAllInfo('Get_ServiceStatus')
                  .subscribe(Status=>{
                      console.log(datos);

                      /**SELECT ON DEMAND */
                      // Service Site
                      this.newSiteSelect.placeholder = datos[0].SITEID + "-" + datos[0].SITENAME
                      this.newSWO.get('siteid').setValue(datos[0].SITEID);
                      this.sitename = datos[0].SITENAME
                      this.nombreNavigateTo = datos[0].SITEID + "-" + datos[0].SITENAME
                      this.siteAddress = datos[0].SITEADDRESS;

                      //requested By
                      datos[0].REQUESTBYID ? '' : datos[0].REQUESTBYID = 0;
                      this.newSWO.get('requestedbyid').setValue(datos[0].REQUESTBYID);
                      this.request = datos[0].First + " " + datos[0].Last
                      this.newRequestSelect.placeholder = datos[0].First + " " + datos[0].Last

                      //Sales Project
                      this.newSWO.get('projectid').setValue(datos[0].PROJECTID);
                      this.salesProject = datos[0].QUOTE
                      this.newProjectSelect.placeholder = datos[0].QUOTE

                      //Responsible
                      this.newSWO.get('servicedoneby').setValue(datos[0].RESPONSIBLEID);
                      this.responsible = datos[0].RESPONSIBLENAME
                      this.newResponsibleSelect.placeholder = datos[0].RESPONSIBLENAME

                      this.newSWO.get('serviceid').setValue(param);
                      this.servicesid = param
                      this.serviceID = param
                      this.createdBy = datos[0].CREATEDBYNAME
                      this.createdDate = this.pipeDate.transform(datos[0].DATECREATED, 'MM/dd/yyyy');
                      this.serviceDoneBy = datos[0].SERVICEDONEBY
                      this.serviceDoneDate = this.pipeDate.transform(datos[0].SERVICEDONEDATE, 'MM/dd/yyyy');

                      if(datos[0].PMCategoriesID != undefined){
                        let pmtasks = datos[0].PMCategoriesID.split(",")
                        PMtype.forEach((element,index) => {
                          if(element.SPMCATEGORY != ""){
                            this.loadInfo.pmType.push(element)
                          }
                          pmtasks.forEach(pmtask1 => {
                            if(element.ID == parseInt(pmtask1)){
                              console.log("aqui")
                              this.pmtype.push(element.ID)
                            }
                          });
                        });
                      } else {
                        PMtype.forEach((element,index) => {
                          if(element.SPMCATEGORY != ""){
                            this.loadInfo.pmType.push(element)
                          }
                        })
                      }

                      // this.todasCategory = allCategory
                      // this.todasTypes = allTypes

                      allCategory.forEach((element,index) => {
                        if(element.SERVICETYPE != ""){
                          this.loadInfo.servicetype.push(element)
                        }
                        if(element.ID == datos[0].SERVICETYPEID){
                          this.newSWO.get('servicetype').setValue(element.ID);
                          this.type = element.ID
                        }
                      });
                      priority.forEach((element,index) => {
                        if(element.name != ""){
                          this.loadInfo.priorityid.push(element)
                        }
                        if(element.ID == datos[0].PRIOROTYID){
                          this.newSWO.get('priorityid').setValue(element.ID);
                          this.priority = element.ID
                        }
                      });
                      allTypes.forEach((element,index) => {
                        if(element.NAME != ""){
                          this.loadInfo.servicecategoryid.push(element)
                        }
                        if(element.ID == datos[0].SERVICECATEGORYID){
                          this.newSWO.get('servicecategoryid').setValue(element.ID);
                          this.category = element.ID
                        }
                      });
                      this.siteID = datos[0].SITEID
                      let result: MarketPoiInterface[] = [];
                      let dataSite = []
                      sites.forEach(element => {
                        if(element.SITENAME != ""){
                          this.loadInfo.siteid.push(element)
                        }
                        if(element.ID == datos[0].SITEID){
                          this.lat = element.LAT
                          this.lng = element.LON
                          result.push({
                            ID: parseInt(element.ID),
                            Lat: parseFloat(element.LAT),
                            lng: parseFloat(element.LON),
                            name: element.SITENAME,
                            zoom: 9,
                            icon: { url: '/assets/img/map/iconoSites.png', scaledSize: { height: 45, width: 45 } },
                            owner: element.OWNERNAME,
                            show: true,
                            VerticalMarket:element.VERTMARKETDESCRIPTION,
                            HasContract:element.HASCONTRACT? "Yes":"No",
                            Active:element.ACTIVE,
                            sale:element.SALESSITE == true ? "Yes":"No"
                        });
                        } else {
                          dataSite.push({
                            ID: parseInt(element.ID),
                            Lat: parseFloat(element.LAT),
                            lng: parseFloat(element.LON),
                            name: element.SITENAME,
                            zoom: 9,
                            icon: { url: '/assets/img/map/iconoSites.png', scaledSize: { height: 45, width: 45 } },
                            owner: element.OWNERNAME,
                            show: false,
                            VerticalMarket:element.VERTMARKETDESCRIPTION,
                            HasContract:element.HASCONTRACT? "Yes":"No"
                          });
                        }
                      });
                      // this._interfacectrlmapService.POI = dataSite;

                      // this._interfacectrlmapService.POI.unshift(result[0])


                      if(datos[0].RESOURCES != undefined){
                        let recursos = datos[0].RESOURCES.split(",");
                        let recursosIDS = datos[0].RESOURCESIDS.split(",");
                        console.log('Recursos ', recursos);
                        console.log('Resources ', resources)
                        resources.forEach((element,index) => {
                          if(element.CONTACTNAME != ""){
                            this.loadInfo.resources.push(element)
                          }
                          recursosIDS.forEach(recurso => {
                            // if(element.CONTACTNAME.trim() == recurso.trim()){
                            //   this.recursos.push(element.ID)
                            // }
                            if(element.ID == Number(recurso)){
                              this.recursos.push(element.ID)
                            }
                          });
                        });
                        console.log('Recursos IDS ', this.recursos);
                      } else {
                        resources.forEach((element,index) => {
                          if(element.CONTACTNAME != ""){
                            this.loadInfo.resources.push(element)
                          }
                        })
                      }


                      if(datos[0].CUSTOMERPO != null){
                        this.newSWO.get('customerpo').setValue(datos[0].CUSTOMERPO);
                        this.loadInfo.customerpo = datos[0].CUSTOMERPO
                      } else {
                        this.loadInfo.customerpo = ""
                      }

                      if(datos[0].REASONFORSERVICE != null){
                        this.newSWO.get('reasonforservice').setValue(datos[0].REASONFORSERVICE);
                        this.loadInfo.reasonforservice = datos[0].REASONFORSERVICE
                      } else {
                        this.loadInfo.reasonforservice = ""
                      }

                      if(datos[0].CALLAHEAD != null){
                        this.newSWO.get('callahead').setValue(datos[0].CALLAHEAD);
                        this.callahead = datos[0].CALLAHEAD
                      } else {
                        this.callahead = false
                      }

                      if(datos[0].REQDATE != null){
                        this.newSWO.get('requestdate').setValue(new Date(datos[0].REQDATE).getTime());
                        this.reqDate.showDate = new Date(datos[0].REQDATE).getTime()
                      } else {
                        this.reqDate.showDate = new Date().getTime()
                      }

                      if(datos[0].SCHEDULEDATE != null){
                        this.newSWO.get('scheduledate').setValue(new Date(datos[0].SCHEDULEDATE).getTime());
                        this.schedulatedDate.showDate = new Date(datos[0].SCHEDULEDATE).getTime()
                      } else {
                        this.schedulatedDate.showDate = new Date().getTime()
                      }

                      if(datos[0].SERVESTIMATEHOURS != null){
                        this.newSWO.get('serviceestimatedhours').setValue(datos[0].SERVESTIMATEHOURS);
                        this.serviceestimatedhours = datos[0].SERVESTIMATEHOURS
                      } else {
                        this.serviceestimatedhours = ""
                      }

                      if(datos[0].SERVCONFIRMED != null){
                        this.newSWO.get('serviceconfirmed').setValue(datos[0].SERVCONFIRMED);
                        this.serviceconfirmed = datos[0].SERVCONFIRMED;
                      }else {
                        this.serviceconfirmed = false
                      }


                      Status.forEach((element,index) => {
                        if(element.STATUS != ""){
                          this.loadInfo.status.push(element)
                        }
                        if(element.ID == datos[0].SERVICESTATUSID){
                          this.newSWO.get('statusid').setValue(element.ID);
                          this.status = element.ID
                        }
                      });
                      // if(datos[0].PROJECTID != undefined){
                      //   this.projectID = datos[0].PROJECTID
                      // } else {
                      //   this.projectID = ""
                      // }
                      if(datos[0].SERVICEID != undefined){
                        this.serviceID = datos[0].SERVICEID
                      } else {
                        this.serviceID = ""
                      }
                      // localStorage.removeItem('newSwoEdit')
                      // this.SearchAllSwo()
                    // })
                  })
                })
              })
            })
          })
        })
      })

      /***Selects onDemand */

    let mythis = this;
    this.siteDataSource = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = " "
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.MapInformationService.GetAllInfoDinamico('Get_ServiceSites',loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            console.log(data)
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });

    this.requestDataSource = new CustomStore({
      key: "ID",
      useDefaultSearch: false,
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = "je"
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.contactService.GetContactByName(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            console.log(data);
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });

    this.projectDataSource = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = " "
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.MapInformationService.GetAllInfoDinamico('Get_SalesProjectList',loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            console.log(data)
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
        }
      });

    this.ResponsibleDataSource = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        return mythis.MapInformationService.GetAllInfo('Get_EmployeeListAll')
          .toPromise()
          .then((data: any) => {
            console.log(data)
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
        }
      });
    })

    this.swoService.GetTemplates('WOReport').subscribe(result => {
      this.templates = []
      console.log('Templates');
      console.log(result);
      this.templatesO = result;
      this.templatesO.forEach(element => {
        this.templates.push(element.CLIENTNAME);
      });
      this.templates.push("Template III")
    });
  }
  templates:any[]=[]
  templatesO:any[]=[]

  SaveInfo(){
    if(this.newSWO.value.callahead){this.newSWO.value.callahead = 1} else {this.newSWO.value.callahead = 0}
    if(this.newSWO.value.serviceconfirmed){this.newSWO.value.serviceconfirmed = 1} else {this.newSWO.value.serviceconfirmed = 0}

    let resourcesString = "";
      if(this.newSWO.value.resources.length != 0){
        this.newSWO.value.resources.forEach((element,index) => {
          if(resourcesString == ""){
            resourcesString += element.toString()
          } else {
            resourcesString += ","+element.toString()
          }
        });

      } else {
        resourcesString = "0"
      }

      let pmtasks = ""
      if(this.newSWO.value.pmtasks.length != 0){
        this.newSWO.value.pmtasks.forEach((element,index) => {
          if(index == 0){
            pmtasks += element.toString()
          } else {
            pmtasks += ","+element.toString()
          }
        });

      } else {
      }

    this.newSWO.value.method = "Insert_ServiceCU"

    this.newSWO.value.requestdate = new Date(this.newSWO.value.requestdate)
    // this.newSWO.value.scheduledate  = new Date(this.newSWO.value.scheduledate)
    this.newSWO.value.scheduledate = this.pipeDate.transform(this.newSWO.value.scheduledate, 'MM/dd/yyyy hh:mm a')
    

    this.newSWO.value.userid = localStorage.getItem('customerid')

    let formValue = this.newSWO.value


    formValue.serviceid = this.servicesid

    let dataFinal

    dataFinal = {
      serviceid:formValue.serviceid,
      siteid:formValue.siteid,
      customerpo:formValue.customerpo,
      requestdate:formValue.requestdate,
      callahead:formValue.callahead,
      serviceconfirmed:formValue.serviceconfirmed,
      priorityid:formValue.priorityid,
      projectid:formValue.projectid,
      servicetype:formValue.servicetype,
      servicecategoryid:formValue.servicecategoryid,
      resources:resourcesString,
      serviceestimatedhours:formValue.serviceestimatedhours,
      scheduledate:formValue.scheduledate,
      statusid:formValue.statusid,
      reasonforservice:formValue.reasonforservice,
      servicedoneby:formValue.servicedoneby,
      subcontractorid:0,
      pmtasks:pmtasks,
      method:"Insert_ServiceCU"
    }

    formValue.requestedbyid ? dataFinal.requestedbyid = formValue.requestedbyid : '';

    console.log(dataFinal)

    const searchTimeSheet={
      method: 'GetTimeSheets',
      serviceid:this.serviceID,
      timesheetid:0,
      taskid:0
    }
    if(formValue.statusid == 3){
      this.MapInformationService.SaveInfoSites(searchTimeSheet)
      .subscribe(res=>{
        if (res.length > 0){
          dataFinal.servdonedate = new Date()
          this.MapInformationService.SaveInfoSites(dataFinal)
          .subscribe(resp=>{
            console.log(resp)
            this.GetAllInfo(this.serviceID)
            this.toast.success(this.translate.instant('msgUpdSucc'));
            this.onsubmit.emit(true);
          })
        } else {
          this.toast.warning("Please, complete the Service Hours information")
        }
      })
    } else {
      this.MapInformationService.SaveInfoSites(dataFinal)
      .subscribe(resp=>{
        console.log(resp)
        this.GetAllInfo(this.serviceID);
        this.toast.success(this.translate.instant('msgUpdSucc'));
        this.onsubmit.emit(true);
      })
    }
  }

  initVarible(){
    this.servicesid = ""
    this.sitename = ""
    this.siteAddress = ""
    this.request = ""
    this.callahead = ""
    this.serviceconfirmed = ""
    this.loadInfo.customerpo = ""
    this.priority = ""
    this.salesProject = ""
    this.pmtype = []
    this.type = ""
    this.responsible = ""
    this.recursos = []
    this.serviceestimatedhours = ""
    this.status = ""
    this.loadInfo.reasonforservice = ""
  }

  editSalesProject(){}

  initForm(){
    this.newSWO = new FormGroup({
      serviceid: new FormControl({ value: '', disabled: true }, []),
      siteid: new FormControl({ value: '', disabled: false }, [Validators.required]),
      servicetype: new FormControl({ value: '', disabled: false }, [Validators.required]),
      servicecategoryid: new FormControl({ value: '', disabled: false }, [Validators.required]),
      requestedbyid: new FormControl({ value: '', disabled: false }, [Validators.required]),
      requestdate: new FormControl(""),
      customerpo: new FormControl({ value: '', disabled: false }, []),
      userid: new FormControl({ value: '', disabled: false }, [Validators.required]),
      resources: new FormControl({ value: '', disabled: false }, []),
      serviceestimatedhours: new FormControl(''),
      scheduledate: new FormControl({ value: "", disabled: false }, [Validators.required]),
      callahead: new FormControl(false),
      serviceconfirmed: new FormControl(false),
      projectid: new FormControl({ value: '', disabled: false }, []),
      priorityid: new FormControl({ value: '', disabled: false }, [Validators.required]),
      reasonforservice: new FormControl(''),
      Notify_Technician: new FormControl(false),
      statusid: new FormControl({ value: 0, disabled: false }, []),
      siteAddress: new FormControl({ value: "", disabled: false }, []),
      pmtasks: new FormControl({ value: "", disabled: false }, []),
      servicedoneby: new FormControl({ value: "", disabled: false }, []),
    });
  }

}
